<template>
  <div>
    <yjh-header :activeIndex="idnex"></yjh-header>
    <div class="detail">
      <div class="topBox">
        <div class="title">{{ detail.title }}</div>
        <!-- <a @click="javascript:history.back(-1)">返回上级页面</a> -->
        <div @click="$router.go(-1)">返回</div>
      </div>

      <div class="time">{{ detail.created_at }}</div>
      <div class="content">
        <div class="text" v-html="detail.content"></div>
        <div class="img">
          <video
            v-if="detail.video_url"
            width="300"
            height="150"
            controls
            :src="detail.video_url"
            :poster="detail.cover_image"
          ></video>
          <img v-else :src="detail.cover_image" alt="" />
        </div>
      </div>
    </div>
    <yjh-footer></yjh-footer>
  </div>
</template>

<script>
import footer from "@/layouts/footer";
import header from "@/layouts/header";
import axios from "axios";
export default {
  components: {
    "yjh-footer": footer,
    "yjh-header": header,
  },
  data() {
    return {
      idnex: "3-3",
      id: "",
      detail: "",
    };
  },
  created() {
    // console.log(this.$route.params.id);
    // this.id = this.$route.params.id;
    this.id = this.$route.query.id;
    this.getNews(this.id);
  },
  methods: {
    getNews(id) {
      const _this = this;
      axios
        .get(process.env.VUE_APP_URL + "/api/news/detail?id=" + id)
        .then(function (res) {
          // console.log(res);
          if (res.data.code == 0) {
            _this.detail = res.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  width: 1000px;
  margin: 50px auto;
  .topBox {
    display: flex;
    justify-content: space-between;
    .title {
      font-size: 40px;
      font-weight: 700;
      line-height: 70px;
    }
  }

  .time {
    font-size: 30px;
    color: #da261d;
    line-height: 70px;
  }
  .content {
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
    .text {
      line-height: 30px;
    }
    img {
      width: 400px;
    }
  }
}
</style>
